import ModalSetTrayID from './ModalSetTrayID';

export default ModalSetTrayID;
